import React, { useState, useRef, useEffect, RefObject, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { Div,klass,style,TKlass,TStyle,onClick } from './html'
import { TRecSession, ISession } from './models/session'
import { MidiNote, IMidiNote, IMidiLearn } from './models/midi'
import { IMenuChoice, MenuChoices } from './menu'

////////////////////////////////////////////////////////////////////////////////
// COMMON UI WIDGETS
////////////////////////////////////////////////////////////////////////////////

const L = console.log
const D = Div

/**
 * Header settings gear, exact SVG from Figma (node 3463:60752). The design
 * uses the thin-weight Material `settings`; the bundled icon font only has
 * weight 400, so the glyph ships as a path.
 */
export function GearIcon () {
    return (
        <svg width='24' height='24' viewBox='2 2 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fill='currentColor' d='M11.6923 23.5L11.3116 20.4538C11.0436 20.3641 10.7689 20.2384 10.4875 20.0769C10.2061 19.9153 9.95448 19.7423 9.73268 19.5577L6.91153 20.75L4.60388 16.75L7.04426 14.9058C7.02117 14.7571 7.00482 14.6077 6.99521 14.4577C6.98559 14.3077 6.98078 14.1583 6.98078 14.0096C6.98078 13.8673 6.98559 13.7227 6.99521 13.5759C7.00482 13.4291 7.02117 13.2686 7.04426 13.0942L4.60388 11.25L6.91153 7.26927L9.72306 8.45197C9.96409 8.26094 10.2215 8.08626 10.4952 7.92792C10.7689 7.76957 11.0378 7.64232 11.3019 7.54617L11.6923 4.50002H16.3076L16.6884 7.5558C16.9884 7.66477 17.2599 7.79201 17.5029 7.93752C17.7458 8.08304 17.991 8.25452 18.2384 8.45197L21.0884 7.26927L23.3961 11.25L20.9173 13.123C20.9532 13.2846 20.9727 13.4356 20.9759 13.5759C20.9791 13.7163 20.9807 13.8577 20.9807 14C20.9807 14.1359 20.9775 14.274 20.9711 14.4144C20.9647 14.5548 20.9416 14.7154 20.9019 14.8962L23.3615 16.75L21.0538 20.75L18.2384 19.548C17.991 19.7455 17.7384 19.9202 17.4807 20.0721C17.223 20.224 16.9589 20.348 16.6884 20.4442L16.3076 23.5H11.6923ZM14.0115 17C14.8436 17 15.5516 16.708 16.1355 16.124C16.7195 15.54 17.0115 14.832 17.0115 14C17.0115 13.168 16.7195 12.46 16.1355 11.876C15.5516 11.292 14.8436 11 14.0115 11C13.1692 11 12.4587 11.292 11.8798 11.876C11.301 12.46 11.0116 13.168 11.0116 14C11.0116 14.832 11.301 15.54 11.8798 16.124C12.4587 16.708 13.1692 17 14.0115 17ZM14.0115 15.5C13.5948 15.5 13.2407 15.3542 12.949 15.0625C12.6573 14.7708 12.5115 14.4167 12.5115 14C12.5115 13.5833 12.6573 13.2292 12.949 12.9375C13.2407 12.6458 13.5948 12.5 14.0115 12.5C14.4282 12.5 14.7823 12.6458 15.074 12.9375C15.3657 13.2292 15.5115 13.5833 15.5115 14C15.5115 14.4167 15.3657 14.7708 15.074 15.0625C14.7823 15.3542 14.4282 15.5 14.0115 15.5ZM13 22H14.9654L15.325 19.3211C15.8352 19.1878 16.3016 18.9984 16.724 18.7529C17.1464 18.5074 17.5538 18.1917 17.9461 17.8058L20.4308 18.85L21.4154 17.15L19.2461 15.5154C19.3295 15.2564 19.3862 15.0026 19.4163 14.7538C19.4464 14.5051 19.4615 14.2538 19.4615 14C19.4615 13.7397 19.4464 13.4885 19.4163 13.2461C19.3862 13.0038 19.3295 12.7564 19.2461 12.5038L21.4346 10.85L20.45 9.15L17.9365 10.2096C17.6019 9.85192 17.2009 9.5359 16.7336 9.26155C16.2663 8.98718 15.7936 8.79295 15.3154 8.67885L15 6H13.0154L12.6846 8.66922C12.1743 8.78974 11.7032 8.97436 11.2711 9.22307C10.8391 9.47179 10.4269 9.79231 10.0346 10.1846L7.54998 9.15L6.56536 10.85L8.72498 12.4596C8.64165 12.6968 8.58332 12.9436 8.54998 13.2C8.51665 13.4564 8.49998 13.7263 8.49998 14.0096C8.49998 14.2699 8.51665 14.525 8.54998 14.775C8.58332 15.025 8.63844 15.2718 8.71536 15.5154L6.56536 17.15L7.54998 18.85L10.025 17.8C10.4045 18.1897 10.8102 18.509 11.2423 18.7577C11.6743 19.0064 12.1519 19.1974 12.675 19.3308L13 22Z'/>
        </svg>
    )
}

/**
 * Collapsible status banner under the app header (Figma "Frame 622", node
 * 3463:60780). Variants via `k` (currently only 'danger').
 */
export function Banner ({k, title, children}: {k?:string, title:string, children?:ReactNode}) {
    const [expanded, setExpanded] = useState(true)
    return (
        <Div k={['app-banner', k, !expanded && 'collapsed']}>
            <Div k='head' {...onClick(() => setExpanded(!expanded))}>
                <Div k='chevron symbols'>{expanded ? 'expand_more' : 'chevron_right'}</Div>
                <Div k='title'>{title}</Div>
            </Div>
            {expanded && <Div k='body'>{children}</Div>}
        </Div>
    )
}

export type TPromptArgs = {
    prompt: string
    value: string
    title: string
    onClose: (value?:string) => void
}

export type TDismissOptions = {
    esc?: boolean
    blur?: boolean
    click?: boolean
}

/**
 * CLOSE React component upon Escape, focus-loss or outside pointer/touch
 * @param ref 
 * @param onClose 
 */
export function useDismissOnEvent ({
    ref,
    clear,
    ignore,
    options = {}
} : {
    ref: RefObject<HTMLElement>
    clear: () => void
    // IGNORE touch/pointer event from target (or its ancestors) having given classname 
    ignore?: string
    options?: TDismissOptions
}) {
    // POINTER/TOUCH outside
    if (options.click !== false) {
        useEffect(() => {
            const outside = (e: PointerEvent | TouchEvent) => {
                if (!e.target || !(e.target instanceof Element)) return
                // IGNORE class?
                if (ignore && e.target.closest(`.${ignore}`)) return
                // Fix 3: e.target is EventTarget, need to cast for contains()
                if (ref.current && !ref.current.contains(e.target as Node)) {
                    clear()
                }
            }
            
            document.addEventListener('pointerdown', outside, { capture: true })
            document.addEventListener('touchstart', outside, { capture: true })
            
            return () => {
                document.removeEventListener('pointerdown', outside, { capture: true })
                document.removeEventListener('touchstart', outside, { capture: true })
            }
        }, [ref,clear,ignore])
    }

    // WINDOW/TAB blur
    if (options.blur !== false) {
        useEffect(() => {
            const onBlur = () => clear()
            window.addEventListener('blur', onBlur)
            return () => window.removeEventListener('blur', onBlur)
        }, [ref, clear])
    }

    // ESC key
    if (options.esc !== false) {
        useEffect(() => {
            const onKey = (e: KeyboardEvent) => e.key === 'Escape' && clear()
            document.addEventListener('keydown', onKey)
            return () => document.removeEventListener('keydown', onKey)
        }, [ref, clear])
    }
}


export function Loft({ target, children } : { target: string, children: ReactNode }) {
  // Create a single <div> to portal into
  const [host] = useState<HTMLDivElement>(() => document.createElement('div'))

  useEffect(() => {
    // FIND target container
    const container = document.getElementById(target)
    if (container) {
        // APPEND child to host and REGISTER removal logic
        container.appendChild(host)
        return () => {
            container.removeChild(host)
            // optional: remove container if now empty
            if (!container.childNodes.length) {
                container.parentNode?.removeChild(container)
            }
        }
    }
    else {
        L(`TARGET ${target} could not be found`)
    }
  }, [target, host])

  return createPortal(children, host)
}

// Room a bubble needs below the anchor before it flips above it
const TIP_ROOM = 48
const TIP_GAP = 6
const TIP_DELAY = 400

/**
 * Hover tooltip. Wraps whatever it explains; the bubble is portalled to the
 * body so panel overflow can't clip it, the same way popup menus escape.
 */
export function Tip ({k,text,delay=TIP_DELAY,children}:{
        k?:TKlass
        text:string
        delay?:number
        children:ReactNode
}) {
    const ref = useRef<HTMLDivElement>(null)
    const timer = useRef<number>()
    const [at,setAt] = useState<{top:number,left:number,above:boolean}>()

    const hide = () => {
        window.clearTimeout(timer.current)
        setAt(undefined)
    }

    // An anchor that unmounts under the cursor never sends mouseleave
    useEffect(() => hide,[])

    const show = () => {
        window.clearTimeout(timer.current)
        timer.current = window.setTimeout(() => {
            const rect = ref.current?.getBoundingClientRect()
            if (!rect) {
                return
            }
            const above = rect.bottom + TIP_ROOM > window.innerHeight
            setAt({
                left: rect.left + rect.width / 2,
                top: above ? rect.top - TIP_GAP : rect.bottom + TIP_GAP,
                above,
            })
        },delay)
    }

    return (
        <D  ref={ref}
            k={['tip-anchor',k]}
            onMouseEnter={show}
            onMouseLeave={hide}
        >
            {children}
            {at && createPortal(
                <D  k={['tip',at.above && 'above']}
                    s={{left:`${at.left}px`, top:`${at.top}px`}}
                >{text}</D>,
                document.body // RENDER into body to avoid any parent clipping
            )}
        </D>
    )
}

export const SearchBox = ({k,value,emptyText='Search',editMode:$editMode,onEdit,onSubmit,onBlur:$onBlur}:{
        k:string|string[]
        value?:string
        emptyText?:string
        editMode?:boolean
        onBlur?:()=>void
        onEdit:(value:string)=>void
        onSubmit?:(value:string)=>void
    }) => {
    const [editMode, setEditMode] = useState<false|'plaintext-only'>(false)
    const [content, setContent] = useState<string>(value||'')
    const ref = useRef<HTMLDivElement>(null)
    const modeRef = useRef<false|string>(false)
    // FORCE edit mode via property (as opposed to HTML events)
    if ($editMode && !editMode) setEditMode('plaintext-only')
    useEffect(() => {
            const el = ref.current
            if (el) {
                const empty = !el.innerText?.length
                if (editMode && !modeRef.current) {
                    setEditMode('plaintext-only')
                    el.classList.remove('empty')
                    // FOCUS element (when activated via property `$editMode`)
                    if (document.activeElement !== el) {
                        el.click()
                    }
                    el.focus()
                    el.innerText = content
                    const range = document.createRange()
                    range.selectNodeContents(el)
                    const sel = window.getSelection()
                    if (sel) {
                        sel.removeAllRanges()
                        sel.addRange(range)
                    }
                }
                else if (!editMode && modeRef.current) {
                    if (empty) el.classList.add('empty')
                    el.blur()
                    setContent(el.innerText)
                    el.innerText = empty ? emptyText : el.innerText
                    el.scrollLeft = 0
                }
                modeRef.current = editMode
            }
        },
        [editMode])

    useEffect(() => {
        if (ref.current) {
            ref.current.innerText = empty ? emptyText : content 
        }}, [])

    useEffect(() => {
        if (ref.current) {
            if (!editMode) {
                ref.current.innerText = value ?? emptyText
                setContent(value ?? '')
            }
        }}, [value])

    const onClick = () => !editMode && setEditMode('plaintext-only')
    const onBlur = () => {
        if (editMode) {
            setEditMode(false)
            // ALERT parent
            if ($onBlur) $onBlur()
        }
    }

    const onInput = (e) => {
        if (editMode && onEdit)  {
            onEdit(e.target.innerText)
        }
    }
  
    const onKeyDown = e => {
        if (editMode) {
            const {key,keyCode} = e
            if (key === 'Escape' || key === 'Enter') {
                e.preventDefault()
                if (key === 'Enter' && onSubmit) onSubmit(e.target.innerText)
                setEditMode(false)
                // ALERT parent
                if ($onBlur) $onBlur()
            }
            // FILTER OUT all other non-printable characters
            else if (key.length !== 1 && !MovementKeys[keyCode]) {
                e.preventDefault()
            }
        }
    }
  
    const empty = !content?.length
    return (
      <div {...
        {
            ref,
            role:'textbox',
            tabIndex:0,
            contentEditable:editMode,
            className:klass(k,'searchbox-control',editMode && 'edit',empty && 'empty'),
            'data-searchbox': '',
            onClick, onKeyDown, onInput, onBlur,
        }}/>
    )
}

const MovementKeys = {
    // NAVIGATION
    37: 'Left',
    38: 'Up',
    39: 'Right',
    40: 'Down',
    35: 'End',
    36: 'Home',
    // EDITING
    8: 'Backspace',
    46: 'Delete',
    // SYSTEM
    27: 'Escape',
    // MODIFIERS
    16: 'Shift',
    17: 'Control',
    18: 'Alt',
    91: 'Meta/Command'
}

export function SimpleEditTextBox (
    {
        id,
        k='',
        s={},
        value,
        onChange,
        onEnter,
    }
    : {
        id?:string
        k?:TKlass
        s?:TStyle
        value:string
        onChange:(text:string)=>void
        onEnter:(text:string)=>void
})
{
    const [editMode, setEditMode] = useState<false|'plaintext-only'>(false)

    useEffect(() => {
        if (ref?.current) {
            ref.current.innerText = value
            reset(ref.current)
        }
    })

    function reset (target) {
        setEditMode('plaintext-only')
        target.focus()
        target.innerText = value
        const range = document.createRange()
        range.selectNodeContents(target)
        const sel = window.getSelection()
        if (sel) {
            sel.removeAllRanges()
            sel.addRange(range)
        }
    }

    const ref = useRef<HTMLInputElement>(null)

    function onKeyDown (e) {
        if (!editMode) return
        const {key,keyCode,target} = e
        // CANCEL change
        if (key === 'Escape') {
            e.preventDefault()
            reset(target)
        }
        // FILTER effects of `Enter` but capture its happening
        else if (key === 'Enter') {
            e.preventDefault()
            onEnter(target.innerText)
        }
        // FILTER OUT all other non-printable/non-navigation characters
        else if (key.length !== 1 && !MovementKeys[keyCode]) {
            e.preventDefault()
        }
    }

    function onKeyUp (e) {
        if (!editMode) return
        const {key,target} = e
        // FILTER OUT all non-printable/navigation characters (but Enter)
        onChange(target.innerText)
    }
  
    return (
      <div ref={ref} {...
        {
            id,
            className: klass(editMode ? 'edit' : 'view',k),
            role: 'textbox',
            tabIndex: 0,
            style: style(s),
            contentEditable: editMode,
            onKeyDown,
            onKeyUp,
        }}/>
    )
}

export function EditableTextBox (
    {
        id,
        k='',
        s='',
        value,
        disabled,
        multiline,
        errTxt,
        emptyText='',
        icon,
        active:$active,
        editOn='click',
        onFocus,
        onBlur:$onBlur,
        onEdit,
        onSave}
    : {
        id?:string
        k?:TKlass
        s?:TStyle
        value?:string
        disabled?:boolean
        multiline?:boolean
        errTxt?:string,
        emptyText?:string
        active?: boolean
        icon?: boolean
        editOn?: 'click' | 'dblclick'
        onFocus?:() => void
        onBlur?:() => void
        onEdit?:(text?:string)=>string|undefined
        onSave?:(text?:string)=>string|undefined
    })
{
    const [editMode, setEditMode] = useState<false|'plaintext-only'>(false)
    const [content, setContent] = useState<string>(value?.trim().length ? value.trim() : '')
    // Start inactive so active=true is handled by the existing transition below
    // on first mount, just like a later inactive -> active change.
    const [active,setActive] = useState<boolean>(false)
    const ref = useRef<HTMLInputElement>(null)

    function enterEdit (el) {
        if (disabled || editMode || !el) return
        setEditMode('plaintext-only')
        el.focus()
        el.innerText = content

        // SELECT content
        const range = document.createRange()
        range.selectNodeContents(el)
        const sel = window.getSelection()
        // RESET selection
        if (sel) {
            sel.removeAllRanges()
            sel.addRange(range)
        }

        if (!el.innerText.length) {
            // INPUT CARET will not rest where you expect w/o this (caret is elevated, CSS hacks are unreliable)
            el.innerText = '\u00A0'
        }
        onFocus && setTimeout(onFocus,0)
    }

    /**
     * ACTIVATE edit mode on single-click, unless the box renames on double-click —
     * then the click belongs to whatever surrounds the box (select, drag, delete).
     */
    function onClick (e) {
        if (editOn === 'dblclick' && !editMode) return
        enterEdit(e.currentTarget)
        e.stopPropagation()
    }

    function onDoubleClick (e) {
        if (editOn !== 'dblclick') return
        enterEdit(e.currentTarget)
        // KEEP it off double-click handlers above us (empty chain space creates a chain)
        e.stopPropagation()
    }

    function onKeyDown (e) {
        if (!editMode) return
        if (e.target.innerText === '\u00A0') {
            e.target.innerText = ''
        }
        const {key,keyCode,target} = e

        // COMMIT value
        if (key === 'Enter') {
            if (multiline && e.shiftKey) {
                // NO-OP
            }
            else {
                e.preventDefault()
                e.stopPropagation()
                target.blur()
            }
        }
        // RESET value
        else if (key === 'Escape') {
            target.innerText = value ?? ''
            e.preventDefault()
            e.stopPropagation()
            target.blur()
        }
        // FILTER OUT all special,non-navigation characters
        else if (key.length !== 1 && !MovementKeys[keyCode]) {
            e.preventDefault()
        }
    }
  
    function onKeyUp (e) {
        if (!editMode) return
        const {innerText} = e.target
        if (onEdit) {
            onEdit(innerText.trim())
        }
        // ERASED to empty leaves a lone <br> behind (innerText '\n', not ''),
        // whose line break renders a phantom second line under white-space:pre
        // \u2014 the box visibly grows. Whitespace-only counts as empty, but leave
        // the placeholder nbsp alone or every keyup would reset the caret.
        if (!innerText.trim().length && innerText !== '\u00A0') {
            // INPUT CARET will not rest where you expect w/o this (caret is elevated, CSS hacks are unreliable)
            e.target.innerText = '\u00A0'
        }
    }

    function onBlur (e) {
        if (!editMode) return
        setEditMode(false)
        const {target:{innerText},target:el} = e

        // CAPTURE 'edit' state
        const text:string|undefined = innerText.trim().length ? innerText.trim() : undefined
        const saved = (onSave 
            ? onSave(text)
            : text) ?? ''
        setContent(saved)

        // PREPARE 'view' state
        const empty = !saved.length
        el.scrollLeft = 0 // RESET caret state
        el.innerText = !empty ? saved : emptyText
        $onBlur && setTimeout($onBlur,0)
    }

    useEffect(() => {
        if (!editMode && ref.current) {
            const empty = !value?.length
            setContent(value ?? '')
            ref.current.innerText = !empty ? value : emptyText 
        }
    })

    useEffect(() => {
        const el = ref.current
        if (!el) return
        if ($active && !active) {
            setActive(true)
            enterEdit(el)
        }
        else if (!$active && active) {
            setActive(false)
            el.blur()
        }
    }, [$active,active])

    return (
        <Div k={['editable',k,icon && 'icon',errTxt && 'error',editMode ? 'edit' : 'view']}>
            <D ref={ref} {...
                {
                    id,
                    k: [editMode ? 'edit' : 'view',!editMode && !value?.trim().length && 'empty',k],
                    s,
                    role:'textbox',
                    tabIndex:0,
                    contentEditable:editMode,
                    onClick, onDoubleClick, onKeyDown, onBlur, onKeyUp,
                }}/>
            <Div k='error'>{errTxt}</Div>
        </Div>
    )
}

export const WolffLogo = () => {
    return (
        <svg width='142' height='32' viewBox='0 0 142 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_962_54207)'>
                <path d='M95.5041 9.61274C95.178 10.2201 94.6725 10.6969 93.9873 11.0438C93.3019 11.391 92.4407 11.5642 91.4029 11.5642C90.3916 11.5642 89.5397 11.3974 88.8483 11.0639C88.1562 10.7304 87.6441 10.2601 87.3115 9.65275C86.9787 9.04564 86.8127 8.34173 86.8127 7.54103C86.8127 6.80742 86.9823 6.14352 87.3215 5.54958C87.6608 4.95589 88.1763 4.48222 88.8682 4.12859C89.5598 3.77496 90.405 3.59814 91.4029 3.59814C92.4008 3.59814 93.2455 3.77496 93.9376 4.12859C94.629 4.48222 95.145 4.95589 95.484 5.54958C95.8235 6.14352 95.9931 6.80742 95.9931 7.54103C95.9931 8.31514 95.8299 9.00563 95.5041 9.61274ZM96.1928 1.66659C94.9021 1.05972 93.3053 0.75592 91.4029 0.75592C89.5001 0.75592 87.9035 1.05972 86.613 1.66659C85.3224 2.27395 84.3609 3.08782 83.7292 4.10847C83.0971 5.12911 82.7812 6.26691 82.7812 7.52115C82.7812 8.86906 83.0935 10.0598 83.7192 11.0939C84.3444 12.1282 85.3024 12.9387 86.5931 13.5257C87.8834 14.1129 89.4869 14.4064 91.4029 14.4064C93.3588 14.4064 94.9818 14.1031 96.2726 13.4957C97.5629 12.8886 98.5109 12.068 99.1165 11.0337C99.7219 9.99992 100.025 8.82881 100.025 7.52115C100.025 6.26691 99.7085 5.12911 99.0766 4.10847C98.4445 3.08782 97.4831 2.27395 96.1928 1.66659Z' fill='#DFD1A7'/>
                <path d='M113.428 11.1233H106.425C106.21 11.1233 106.035 10.9482 106.035 10.7321V1.38673C106.035 1.17062 105.86 0.995483 105.645 0.995483H102.593C102.378 0.995483 102.203 1.17062 102.203 1.38673V13.7744C102.203 13.9905 102.378 14.1656 102.593 14.1656H113.428C113.644 14.1656 113.818 13.9905 113.818 13.7744V11.5146C113.818 11.2985 113.644 11.1233 113.428 11.1233Z' fill='#DFD1A7'/>
                <path d='M127.552 0.994507H116.257C116.042 0.994507 115.867 1.16965 115.867 1.38575V3.44525C115.867 3.66135 116.042 3.83649 116.257 3.83649H127.552C127.767 3.83649 127.942 3.66135 127.942 3.44525V1.38575C127.942 1.16965 127.767 0.994507 127.552 0.994507Z' fill='#DFD1A7'/>
                <path d='M127.552 6.75946H116.257C116.042 6.75946 115.867 6.9346 115.867 7.15071V13.7739C115.867 13.99 116.042 14.1651 116.257 14.1651H119.309C119.525 14.1651 119.699 13.99 119.699 13.7739V9.99269C119.699 9.77682 119.874 9.60144 120.089 9.60144H127.552C127.767 9.60144 127.942 9.42631 127.942 9.2102V7.15071C127.942 6.9346 127.767 6.75946 127.552 6.75946Z' fill='#DFD1A7'/>
                <path d='M141.591 0.994507H130.296C130.081 0.994507 129.906 1.16965 129.906 1.38575V3.44525C129.906 3.66135 130.081 3.83649 130.296 3.83649H141.591C141.806 3.83649 141.981 3.66135 141.981 3.44525V1.38575C141.981 1.16965 141.806 0.994507 141.591 0.994507Z' fill='#DFD1A7'/>
                <path d='M141.591 6.75946H130.296C130.081 6.75946 129.906 6.9346 129.906 7.15071V13.7739C129.906 13.99 130.081 14.1651 130.296 14.1651H133.348C133.564 14.1651 133.738 13.99 133.738 13.7739V9.99269C133.738 9.77682 133.913 9.60144 134.128 9.60144H141.591C141.806 9.60144 141.981 9.42631 141.981 9.2102V7.15071C141.981 6.9346 141.806 6.75946 141.591 6.75946Z' fill='#DFD1A7'/>
                <path d='M67.7911 26.1129H63.2245C63.0231 26.1129 62.8927 25.9001 62.9835 25.7199L65.2581 21.2279C65.3579 21.0307 65.6386 21.0303 65.739 21.227L68.0317 25.7192C68.1232 25.8994 67.9927 26.1129 67.7911 26.1129ZM74.874 30.4642L68.1535 18.0769C68.0854 17.9511 67.9538 17.8725 67.8109 17.8725H63.7243C63.5815 17.8725 63.4498 17.9511 63.3815 18.0769L56.6613 30.4642C56.5198 30.7252 56.7081 31.0426 57.0041 31.0426H60.0591C60.2063 31.0426 60.341 30.9597 60.4074 30.8279L61.2438 29.1695C61.3102 29.038 61.4447 28.9548 61.5919 28.9548H69.4369C69.5836 28.9548 69.7181 29.0375 69.7845 29.1686L70.6285 30.8291C70.6952 30.9602 70.8294 31.0426 70.9761 31.0426H74.5312C74.8272 31.0426 75.0154 30.7252 74.874 30.4642Z' fill='#DFD1A7'/>
                <path d='M91.6634 17.8711H89.0109C88.7954 17.8711 88.6208 18.0462 88.6208 18.2623V24.7362C88.6208 25.5638 88.4579 26.2344 88.1318 26.7478C87.8057 27.2617 87.3401 27.6386 86.7349 27.8787C86.1293 28.1187 85.3878 28.239 84.5096 28.239C83.6314 28.239 82.8896 28.1187 82.2842 27.8787C81.6786 27.6386 81.213 27.2617 80.8874 26.7478C80.561 26.2344 80.3984 25.5638 80.3984 24.7362V18.2623C80.3984 18.0462 80.2237 17.8711 80.0082 17.8711H76.9565C76.741 17.8711 76.5664 18.0462 76.5664 18.2623V25.1567C76.5664 26.5178 76.8758 27.6554 77.4943 28.5691C78.113 29.4834 79.0013 30.1638 80.1587 30.6107C81.3162 31.0577 82.7066 31.2813 84.3299 31.2813C85.953 31.2813 87.3401 31.0577 88.4911 30.6107C89.6419 30.1638 90.5234 29.4834 91.1355 28.5691C91.7473 27.6554 92.0535 26.5178 92.0535 25.1567V18.2623C92.0535 18.0462 91.8789 17.8711 91.6634 17.8711Z' fill='#DFD1A7'/>
                <path d='M115.149 17.8716H112.097C111.882 17.8716 111.707 18.0467 111.707 18.2628V30.6502C111.707 30.8663 111.882 31.0417 112.097 31.0417H115.149C115.364 31.0417 115.539 30.8663 115.539 30.6502V18.2628C115.539 18.0467 115.364 17.8716 115.149 17.8716Z' fill='#DFD1A7'/>
                <path d='M130.563 26.4893C130.237 27.0966 129.731 27.5734 129.046 27.9203C128.361 28.2675 127.499 28.4407 126.461 28.4407C125.45 28.4407 124.599 28.274 123.907 27.9405C123.215 27.6069 122.703 27.1366 122.37 26.5293C122.038 25.9222 121.871 25.2183 121.871 24.4176C121.871 23.6839 122.041 23.02 122.38 22.4261C122.719 21.8324 123.235 21.3587 123.927 21.0051C124.619 20.6515 125.464 20.4747 126.461 20.4747C127.459 20.4747 128.304 20.6515 128.996 21.0051C129.688 21.3587 130.204 21.8324 130.543 22.4261C130.882 23.02 131.052 23.6839 131.052 24.4176C131.052 25.1917 130.889 25.8822 130.563 26.4893ZM134.135 20.985C133.503 19.9643 132.542 19.1505 131.251 18.5431C129.961 17.9362 128.364 17.6324 126.461 17.6324C124.559 17.6324 122.962 17.9362 121.672 18.5431C120.381 19.1505 119.419 19.9643 118.788 20.985C118.156 22.0056 117.84 23.1434 117.84 24.3977C117.84 25.7456 118.152 26.9363 118.778 27.9704C119.403 29.0047 120.361 29.8152 121.652 30.4022C122.942 30.9894 124.546 31.2829 126.461 31.2829C128.418 31.2829 130.04 30.9796 131.331 30.3723C132.622 29.7651 133.57 28.9446 134.175 27.9103C134.78 26.8764 135.083 25.7053 135.083 24.3977C135.083 23.1434 134.767 22.0056 134.135 20.985Z' fill='#DFD1A7'/>
                <path d='M139.269 28.4218H139.658C139.715 28.4218 139.769 28.4086 139.82 28.382C139.87 28.3557 139.911 28.3171 139.942 28.2663C139.972 28.2157 139.988 28.1573 139.988 28.0912C139.988 28.0207 139.972 27.9601 139.942 27.9093C139.911 27.8588 139.87 27.819 139.82 27.7902C139.769 27.7617 139.715 27.7473 139.658 27.7473H139.269V28.4218ZM138.603 29.7841V27.2116H139.619C139.922 27.2116 140.17 27.2823 140.364 27.4232C140.557 27.5645 140.654 27.7715 140.654 28.0449C140.654 28.1506 140.641 28.2466 140.614 28.3324C140.588 28.4184 140.551 28.4934 140.505 28.5574C140.459 28.6214 140.404 28.6753 140.341 28.7193C140.277 28.7634 140.207 28.7965 140.133 28.8185L140.753 29.7841H140.014L139.539 28.9244H139.269V29.7841H138.603ZM139.564 30.4889C139.839 30.4889 140.097 30.4377 140.337 30.3351C140.577 30.2328 140.789 30.0898 140.972 29.9063C141.155 29.7227 141.297 29.5107 141.4 29.2699C141.502 29.0294 141.553 28.773 141.553 28.5013C141.553 28.2251 141.502 27.9663 141.4 27.7258C141.297 27.485 141.155 27.273 140.972 27.0894C140.789 26.9059 140.577 26.7631 140.337 26.6606C140.097 26.558 139.839 26.5068 139.564 26.5068C139.293 26.5068 139.037 26.558 138.797 26.6606C138.557 26.7631 138.346 26.9059 138.163 27.0894C137.98 27.273 137.837 27.485 137.735 27.7258C137.633 27.9663 137.582 28.2251 137.582 28.5013C137.582 28.773 137.633 29.0294 137.735 29.2699C137.837 29.5107 137.98 29.7227 138.163 29.9063C138.346 30.0898 138.557 30.2328 138.797 30.3351C139.037 30.4377 139.293 30.4889 139.564 30.4889ZM139.564 30.9394C139.231 30.9394 138.917 30.8761 138.623 30.7499C138.328 30.6236 138.069 30.4484 137.846 30.2244C137.622 30.0004 137.448 29.7407 137.322 29.4451C137.196 29.1496 137.133 28.8351 137.133 28.5013C137.133 28.163 137.196 27.8461 137.322 27.5506C137.448 27.255 137.622 26.9953 137.846 26.7713C138.069 26.5472 138.328 26.3721 138.623 26.2458C138.917 26.1196 139.231 26.0563 139.564 26.0563C139.901 26.0563 140.217 26.1196 140.512 26.2458C140.807 26.3721 141.066 26.5472 141.289 26.7713C141.512 26.9953 141.687 27.255 141.813 27.5506C141.939 27.8461 142.002 28.163 142.002 28.5013C142.002 28.8351 141.939 29.1496 141.813 29.4451C141.687 29.7407 141.512 30.0004 141.289 30.2244C141.066 30.4484 140.807 30.6236 140.512 30.7499C140.217 30.8761 139.901 30.9394 139.564 30.9394Z' fill='#DFD1A7'/>
                <path d='M81.4015 0.994995H78.4784C78.315 0.994995 78.169 1.09706 78.1124 1.25064L74.8736 10.0418H74.8335L71.4965 1.24704C71.4389 1.09538 71.2939 0.994995 71.132 0.994995H67.7964C67.6352 0.994995 67.4907 1.09442 67.4326 1.24489L64.0364 10.0418H63.9965L60.6003 1.24512C60.5423 1.09442 60.3977 0.994995 60.2365 0.994995H56.9296C56.6535 0.994995 56.4647 1.27483 56.5675 1.53191L61.5232 13.9195C61.5827 14.0678 61.726 14.1651 61.8854 14.1651H65.568C65.7278 14.1651 65.8714 14.0674 65.9304 13.9183L69.2055 5.65856H69.2454L72.4024 13.9138C72.4602 14.0652 72.6053 14.1651 72.7668 14.1651H76.4458C76.6052 14.1651 76.7485 14.0678 76.808 13.9195L81.7637 1.53191C81.8664 1.27483 81.6777 0.994995 81.4015 0.994995Z' fill='#DFD1A7'/>
                <path d='M101.393 17.8718H95.1C94.8829 17.8718 94.707 18.0482 94.707 18.2659V20.3199C94.707 20.5375 94.8829 20.7141 95.1 20.7141H101.592C104.686 20.7141 105.803 22.3751 105.803 24.4566C105.803 26.8786 104.686 28.1995 101.852 28.1995H98.9317C98.7148 28.1995 98.539 28.0231 98.539 27.8056V24.0302C98.539 23.8126 98.3629 23.6361 98.146 23.6361H95.1C94.8829 23.6361 94.707 23.8126 94.707 24.0302V30.6476C94.707 30.8654 94.8829 31.0417 95.1 31.0417H101.972C107.52 31.0417 109.635 28.6798 109.635 24.4566C109.635 20.7339 107.56 17.8718 101.393 17.8718Z' fill='#DFD1A7'/>
                <path d='M51.7313 0H0V32H51.7313V0Z' fill='#DFD1A7'/>
                <path d='M49.9814 0.947327H1.88808C1.44277 0.947327 1.08203 1.30934 1.08203 1.75569V30.2453C1.08203 30.6916 1.44277 31.0536 1.88808 31.0536H49.9814C50.4267 31.0536 50.7875 30.6916 50.7875 30.2453V1.75569C50.7875 1.30934 50.4267 0.947327 49.9814 0.947327Z' fill='#101820'/>
                <path d='M5.72927 4.76169C5.24456 4.75891 4.89132 5.15082 4.88855 5.63692L4.87906 26.3893C4.86712 27.0179 5.56669 27.4493 6.12838 27.1424L22.7651 18.8227C23.3268 18.5158 24.0264 18.9473 24.0145 19.5758L24.0174 26.3983C24.0055 27.0269 24.705 27.4583 25.2667 27.1514L46.5299 16.5282C46.7984 16.3453 47.0174 16.0448 46.994 15.743L46.9985 6.14625C47.0104 5.51771 46.3109 5.08625 45.7492 5.39315L29.1124 13.7129C28.509 14.0027 27.8512 13.5883 27.8631 12.9597L27.8601 6.13724C27.8721 5.5087 27.1725 5.07724 26.6108 5.38414L9.97406 13.7038C9.37068 13.9937 8.71281 13.5793 8.68305 12.9337L8.68287 5.62512C8.68564 5.13902 8.31181 4.74295 7.8271 4.74017L5.72927 4.76169Z' fill='url(#paint0_linear_962_54207)'/>
            </g>
            <defs>
                <linearGradient id='paint0_linear_962_54207' x1='3.13421' y1='6.96782' x2='44.8583' y2='23.8857' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#EC2024'/>
                    <stop offset='0.35' stopColor='#FC4C02'/>
                    <stop offset='1' stopColor='#FFC907'/>
                </linearGradient>
                <clipPath id='clip0_962_54207'>
                    <rect width='142' height='32' fill='white'/>
                </clipPath>
            </defs>
        </svg>
    )
}


export function AppInfo (
    {k,data:$data,clear,onReleaseNotes}:
    {
        k?: TKlass,
        data: Record<string,string|null>
        clear: ()=>void
        onReleaseNotes?: ()=>void
    }) {
    const ref = useRef(null)

    useDismissOnEvent({ref,clear})
    const data =
        Object.fromEntries(
            Object.entries($data)
                .filter(([_,v]) => v)) as Record<string,string>

    // Group fields for visual hierarchy
    const appFields = ['version', 'channel', 'build', 'wolffhound']
    const systemFields = ['browser', 'os', 'device']
    const unitFields = ['unit s/n']

    const renderGroup = (fields: string[], groupClass?: string) => {
        const entries = Object.entries(data).filter(([k]) => fields.includes(k))
        if (entries.length === 0) return null
        return (
            <Div k={['app-info-group', groupClass]}>
                {entries.map(([k,v]) => (
                    <Div k='app-info-row' key={k}>
                        <Div k='app-info-key'>{k}</Div>
                        <Div k='app-info-value'>{v}</Div>
                    </Div>
                ))}
            </Div>
        )
    }

    async function copy () {
        if (!navigator.clipboard) { clear(); return }
        const text =
            Object
            .entries(data)
            .map(([k,v]) => `${k}: ${v}`)
            .join('\n')

        setTimeout(clear,0)
        try {
            await navigator.clipboard.writeText(text)
        }
        catch (e) {
            L('CLIPBOARD COPY FAILED', e)
        }
    }

    return (
        <Loft target='root'>
            <D k={['modal',k]} style={{display:'block'}} ref={ref}>
                <Div k='dialog app-info-dialog'>
                    <Div k='titlebar'>PAW: APP/ENV INFO
                        <Div k='dismiss' {...onClick(clear)}>close</Div>
                    </Div>
                    <Div k='body'>
                        <Div k='prompt'>ProPatch App for the Web</Div>
                        <Div k='app-info-content'>
                            {renderGroup(appFields, 'app')}
                            {renderGroup(systemFields, 'system')}
                            {renderGroup(unitFields, 'unit')}
                        </Div>
                        {onReleaseNotes &&
                            <Div k='release-notes-link' {...onClick(onReleaseNotes)}>
                                <span className='release-notes-icon'>◆</span>
                                <span>Release Notes</span>
                                <span className='release-notes-chevron'>›</span>
                            </Div>
                        }
                        <Div k='actions'>
                            <Div k='cta secondary' {...onClick(clear)}>OK</Div>
                            <Div k='cta primary' {...onClick(copy)}>COPY</Div>
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

export function Popup (
    {
        k,
        title,
        prompt,
        yes,
        no,
        clear=()=>{},
        options,
        destructive=false,
        yesLabel='YES',
        noLabel='NO',
        noDanger=false,
        cancelLabel,
        confirmOnEnter=false,
    }:
    {
        k:string
        title:string
        prompt:string
        yes?:()=>void
        no?:()=>void
        clear:()=>void
        options?: TDismissOptions
        destructive?: boolean
        yesLabel?: string
        noLabel?: string
        noDanger?: boolean
        cancelLabel?: string
        confirmOnEnter?: boolean
    }) {
    const ref = useRef(null)
    const style = prompt ? {display: 'block'} : {display: 'none'}
    const confirm = () => { yes && yes(); clear() }
    const decline = () => { no && no(); clear() }

    useDismissOnEvent({ref,clear,options})

    useEffect(() => {
        if (!yes || !confirmOnEnter) return
        const onKey = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                event.preventDefault()
                confirm()
            }
        }
        document.addEventListener('keydown',onKey)
        return () => document.removeEventListener('keydown',onKey)
    }, [yes,clear,confirmOnEnter])

    return (
        <Loft target='root'>
            <D k={['modal',k]} style={style} ref={ref}>
                <Div k={['dialog',destructive && 'destructive',cancelLabel && 'three-outcome']}>
                    <Div k='titlebar'>{title}
                        <Div k='dismiss' {...onClick(!yes ? decline : clear)}>close</Div>
                    </Div>
                    <Div k='body'>
                        <Div k='prompt'>{prompt}</Div>
                        <Div k='actions'>
                            {!yes
                                ? <Div k='cta secondary' {...onClick(clear)}>OK</Div>
                                : 
                                <>
                                    <Div k={['cta','secondary',noDanger && 'danger',noDanger && 'quiet']} {...onClick(decline)}>{noLabel}</Div>
                                    {cancelLabel && <Div k='cta secondary' {...onClick(clear)}>{cancelLabel}</Div>}
                                    <Div k='cta primary' {...onClick(confirm)}>{yesLabel}</Div>
                                </>
                            }
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

/**
 * Modally prompt for value. Value is received via `onClose` if accepted.
 * If canceled, value is `undefined`.
 */
export function Prompt ({
        k,
        title,
        prompt,
        value,
        onClose,
        options,
}: {
        k: string
        title: string
        prompt: string
        value: string
        onClose: (value?:string) => void
        options?: TDismissOptions
    })
{
    const ref = useRef(null)
    const valueRef = useRef<string>(value)
    const style = {display: 'block'}
    useDismissOnEvent({ref,clear: () => onClose(),options})

    return (
        <Loft target='space'>
            <D k={['modal',k]} style={style} ref={ref}>
                <Div k='dialog'>
                    <Div k='titlebar'>{title}
                        <Div k='dismiss' {...onClick(() => onClose())}>close</Div>
                    </Div>
                    <Div k='body'>
                        <Div k='prompt'>{prompt}</Div>
                        <SimpleEditTextBox
                            k='value'
                            value={value}
                            onEnter={() => onClose(valueRef.current)}
                            onChange={$value => valueRef.current = $value}
                        />
                        <Div k='actions'>
                            <Div k='cta secondary' {...onClick(() => onClose())}>
                                CANCEL
                            </Div>
                            <Div k='cta primary' {...onClick(() => onClose(valueRef.current))}>
                                OK
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

////////////////////////////////////////////////////////////////////////////////
// CREATE SESSION DIALOG
////////////////////////////////////////////////////////////////////////////////

export interface ICreateSessionResult {
    name: string
    templateId?: string
    importChains?: boolean
}

export type TCreateSessionDialogProps = {
    sessions: TRecSession
    defaultSessionName: string
    currentSessionName?: string
    initialSessionType?: 'blank' | 'template'
    initialTemplateId?: string
    findUniqueName: (sessions: TRecSession, name: string) => string
    onClose: (result?: ICreateSessionResult) => void
}

export function CreateSessionDialog({
    sessions,
    defaultSessionName,
    currentSessionName,
    initialSessionType = 'blank',
    initialTemplateId,
    findUniqueName,
    onClose
}: TCreateSessionDialogProps) {
    const ref = useRef<HTMLDivElement>(null)

    // The session you came from leads the list: branching off it is the common
    // case, and it's the one you'd otherwise go hunting for. Then the default,
    // then by recent access.
    const rank = (s: ISession) =>
        s.name === currentSessionName ? 0
        : s.name === defaultSessionName ? 1
        : 2
    const sortedSessions = Object.values(sessions)
        .sort((a, b) => rank(a) - rank(b) || b.meta.accessed.localeCompare(a.meta.accessed))

    // Form state - use ref for name to avoid SimpleEditTextBox re-render bug
    const initialName = findUniqueName(sessions, defaultSessionName)
    const nameRef = useRef<string>(initialName)
    const [sessionType, setSessionType] = useState<'blank' | 'template'>(initialSessionType)
    const [templateId, setTemplateId] = useState<string | undefined>(
        initialTemplateId ?? (sortedSessions.length > 0 ? sortedSessions[0].name : undefined)
    )
    const [importChains, setImportChains] = useState<boolean>(true)
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    const dropdownRef = useRef<HTMLDivElement>(null)

    // Close dropdown on click outside
    useEffect(() => {
        if (!dropdownOpen) return
        const handleClickOutside = (e: PointerEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setDropdownOpen(false)
            }
        }
        document.addEventListener('pointerdown', handleClickOutside)
        return () => document.removeEventListener('pointerdown', handleClickOutside)
    }, [dropdownOpen])

    const selectedTemplate = templateId ? sessions[templateId] : undefined

    // Check if template has chains
    const templateHasChains = selectedTemplate
        ? (Array.isArray(selectedTemplate.chains)
            ? selectedTemplate.chains.length > 0
            : Object.keys(selectedTemplate.chains).length > 0)
        : false

    // Handle dismiss via ESC/click-outside
    useDismissOnEvent({ ref, clear: () => onClose() })

    const handleOK = () => {
        const name = nameRef.current.trim()
        // Validate name
        if (!name.length || name.length > 64 || sessions[name]) return
        // Validate template selection
        if (sessionType === 'template' && !templateId) return

        onClose({
            name,
            templateId: sessionType === 'template' ? templateId : undefined,
            importChains: sessionType === 'template' && templateHasChains ? importChains : undefined,
        })
    }

    return (
        <Loft target='space'>
            <D k={['modal', 'create-session']} style={{ display: 'block' }} ref={ref}>
                <Div k='dialog'>
                    <Div k='titlebar'>NEW SESSION
                        <Div k='dismiss' {...onClick(() => onClose())}>close</Div>
                    </Div>
                    <Div k='body'>
                        {/* Session name input */}
                        <Div k='field'>
                            <Div k='label'>Session Name</Div>
                            <SimpleEditTextBox
                                k='value'
                                value={initialName}
                                onEnter={handleOK}
                                onChange={v => nameRef.current = v}
                            />
                        </Div>

                        {/* Radio options */}
                        <Div k='options'>
                            <D
                                k={['option', sessionType === 'blank' && 'selected']}
                                {...onClick(() => setSessionType('blank'))}
                            >
                                <D k='radio'>{sessionType === 'blank' ? 'radio_button_checked' : 'radio_button_unchecked'}</D>
                                <D k='text'>New blank session</D>
                            </D>
                            <D
                                k={['option', sessionType === 'template' && 'selected']}
                                {...onClick(() => setSessionType('template'))}
                            >
                                <D k='radio'>{sessionType === 'template' ? 'radio_button_checked' : 'radio_button_unchecked'}</D>
                                <D k='text'>New from existing session</D>
                            </D>
                        </Div>

                        {/* Template selection (visible when "New from existing session" selected) */}
                        {sessionType === 'template' && (
                            <Div k='template-section'>
                                <Div k='field'>
                                    <Div k='label'>Template Session</Div>
                                    <Div k='template-dropdown' ref={dropdownRef} {...onClick(() => setDropdownOpen(!dropdownOpen))}>
                                        <Div k='selected'>
                                            {selectedTemplate?.name ?? 'Select a session...'}
                                        </Div>
                                        <Div k='arrow'>keyboard_arrow_down</Div>
                                        {dropdownOpen && (
                                            <Div k='dropdown-list'>
                                                {sortedSessions.map(s => (
                                                    <Div
                                                        key={s.id}
                                                        k={['dropdown-item', s.name === templateId && 'selected']}
                                                        {...onClick((e) => {
                                                            e.stopPropagation()
                                                            setTemplateId(s.name)
                                                            setDropdownOpen(false)
                                                        })}
                                                    >
                                                        {(s.meta.locked || s.meta.immutable) && (
                                                            <D k={['locked', s.meta.immutable && 'immutable']}>lock</D>
                                                        )}
                                                        <D k='name'>{s.name}</D>
                                                    </Div>
                                                ))}
                                            </Div>
                                        )}
                                    </Div>
                                </Div>

                                {/* Import chains checkbox */}
                                <Div k='field'>
                                    <D
                                        k={['checkbox-row', !templateHasChains && 'disabled']}
                                        {...onClick(() => templateHasChains && setImportChains(!importChains))}
                                    >
                                        <D k='checkbox'>
                                            {importChains && templateHasChains ? 'check_box' : 'check_box_outline_blank'}
                                        </D>
                                        <D k='text'>
                                            Import chains from session
                                            {!templateHasChains && <span className='no-chains'> (no chains)</span>}
                                        </D>
                                    </D>
                                </Div>
                            </Div>
                        )}

                        {/* Action buttons */}
                        <Div k='actions'>
                            <Div k='cta secondary' {...onClick(() => onClose())}>
                                CANCEL
                            </Div>
                            <Div
                                k={['cta', 'primary']}
                                {...onClick(handleOK)}
                            >
                                OK
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

export function PopAlert ({k,title='ALERT',prompt,message,dismiss='OK',secondary,clear,options}:{
        k?:string
        title?:string
        dismiss?:string
        secondary?: {
            label: string
            action: () => void
        }
        prompt?:string
        message?:string
        clear:()=>void
        options?: TDismissOptions
    }) 
{

    const ref = useRef(null)
    useDismissOnEvent({ref,clear,options})

    return (
        <Loft target='space'>
            <D k={['modal',k]} style={{display:'block'}} ref={ref}>
                <Div k={['dialog',k]}>
                    <Div k='titlebar'>{title}
                        <Div k='dismiss' {...onClick(clear)}>close</Div>
                    </Div>
                    <Div k='body'>
                        {prompt && <Div k='prompt'>{prompt}</Div>}
                        {message && <Div k='message'>{message}</Div>}
                        <Div k='actions'>
                            {secondary &&
                                <Div k='cta secondary' {...onClick(secondary.action)}>
                                    {secondary.label}
                                </Div>
                            }
                            <Div k='cta primary' {...onClick(clear)}>
                                {dismiss}
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

////////////////////////////////////////////////////////////////////////////////
// SUPPORT DIALOG
////////////////////////////////////////////////////////////////////////////////

export type TSupportDialogArgs = {
    name: string
    email: string
    hasSession: boolean
    env: Record<string, string | null>
    updatePending: boolean
    onClose: (result?: { name: string, email: string, message: string, includeSession: boolean }) => void
}

export function SupportDialog ({
    name,
    email,
    hasSession,
    env,
    updatePending,
    onClose,
}: TSupportDialogArgs) {
    const ref = useRef<HTMLDivElement>(null)
    const nameRef = useRef(name)
    const emailRef = useRef(email)
    const messageRef = useRef('')
    const [includeSession, setIncludeSession] = useState<boolean>(hasSession)
    const [errors, setErrors] = useState<{name?: boolean, email?: boolean}>({})

    useDismissOnEvent({ref, clear: () => onClose()})

    const appFields = ['version', 'channel', 'build', 'wolffhound']
    const systemFields = ['browser', 'os', 'device']

    const renderGroup = (fields: string[], groupClass?: string) => {
        const entries = fields
            .filter(k => env[k])
            .map(k => [k, env[k]!] as const)
        if (entries.length === 0) return null
        return (
            <Div k={['app-info-group', groupClass]}>
                {entries.map(([k,v]) => (
                    <Div k='app-info-row' key={k}>
                        <Div k='app-info-key'>{k}</Div>
                        <Div k='app-info-value'>{v}</Div>
                    </Div>
                ))}
            </Div>
        )
    }

    return (
        <Loft target='root'>
            <D k={['modal','support']} style={{display: 'block'}} ref={ref}>
                <Div k='dialog'>
                    <Div k='titlebar'>SEND TO SUPPORT
                        <Div k='dismiss' {...onClick(() => onClose())}>close</Div>
                    </Div>
                    <Div k='body'>
                        <Div k='prompt'>
                            Environment info will be sent to Wolff Audio support.
                            {updatePending && <Div k='version-stale'>update available</Div>}
                        </Div>
                        <Div k='app-info-content'>
                            {renderGroup(appFields, 'app')}
                            {renderGroup(systemFields, 'system')}
                        </Div>
                        <Div k='field'>
                            <Div k='field-label'>Name</Div>
                            <input
                                className={`support-input${errors.name ? ' error' : ''}`}
                                type='text'
                                defaultValue={name}
                                autoFocus
                                onChange={e => { nameRef.current = e.target.value; setErrors(p => ({...p, name: false})) }}
                            />
                        </Div>
                        <Div k='field'>
                            <Div k='field-label'>Email</Div>
                            <input
                                className={`support-input${errors.email ? ' error' : ''}`}
                                type='email'
                                defaultValue={email}
                                onChange={e => { emailRef.current = e.target.value; setErrors(p => ({...p, email: false})) }}
                            />
                        </Div>
                        <Div k='field'>
                            <Div k='field-label'>Message (optional)</Div>
                            <textarea
                                className='support-message'
                                rows={4}
                                onChange={e => messageRef.current = e.target.value}
                            />
                        </Div>
                        <Div k='field'>
                            <D
                                k={['checkbox-row', !hasSession && 'disabled']}
                                {...onClick(() => hasSession && setIncludeSession(!includeSession))}
                            >
                                <D k='checkbox'>
                                    {includeSession && hasSession ? 'check_box' : 'check_box_outline_blank'}
                                </D>
                                <D k='text'>Include session data</D>
                            </D>
                        </Div>
                        <Div k='actions'>
                            <Div k='cta secondary' {...onClick(() => onClose())}>
                                CANCEL
                            </Div>
                            <Div k='cta primary' {...onClick(() => {
                                const n = nameRef.current.trim()
                                const e = emailRef.current.trim()
                                const emailValid = !!e && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
                                if (!n || !emailValid) {
                                    setErrors({ name: !n, email: !emailValid })
                                    return
                                }
                                onClose({
                                    name: n,
                                    email: e,
                                    message: messageRef.current.trim(),
                                    includeSession: includeSession && hasSession,
                                })
                            })}>
                                SEND
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

/**
 * Zoom is the browser's own shortcut, Cmd on macOS and Ctrl everywhere else.
 * hotkeys.KeyMod always prints 'Cmd', so zoom labels its modifier itself.
 */
function zoomModifier () : string {
    try {
        const ua = navigator.userAgent || ''
        const plat = (navigator.platform || '').toLowerCase()
        return /mac|macintosh|mac os/.test(plat) || /Mac OS X/.test(ua) ? 'Cmd' : 'Ctrl'
    } catch {
        return 'Cmd'
    }
}

export function KeyboardShortcutsModal ({ targets, onClose } : { targets: hotkeys.ITarget[], onClose: () => void }) {
    const ref = useRef<HTMLDivElement>(null)

    // Close on ESC/click/blur via common hook
    useDismissOnEvent({ref,clear:onClose})

    const Key = ({k}:{k:string}) => <span className='keycap'>{k}</span>

    type Row = { action: string, keys: React.ReactNode, keysText: string }

    function Section ({title, rows}:{title:string,rows:Row[]}) {
        return (
            <Div k='section'>
                <Div k='section-title'>{title}</Div>
                {rows.map((r,i) => (
                    <Div k='row' key={i}><Div k='action'>{r.action}</Div><Div k='keys'>{r.keys}</Div></Div>
                ))}
            </Div>
        )
    }

    /**
     * TARGET to DISPLAY ROW
     */
    function toRow (target: hotkeys.ITarget) : Row {
        return {
            action: target.desc,
            keys: [
                hotkeys.KeyMod.toStrings(target.mod),
                target.key
            ]
            .flat()
            .map(_ => <Key key={_} k={_}/>),
            keysText: Array.isArray(target.key) ? target.key.join(',') : target.key,
        }
    }

    /**
     * TARGETS of given CATEGORY to DISPLAY rows
     */
    function toCatRows (cat: string) : Row[] {
        return targets
            .filter(target => target.cat && target.cat.desc === cat)
            .map(toRow)
    }

    return (
        <Loft target='root'>
            <D k={['modal','shortcuts']} style={{display:'block'}} ref={ref}>
                <Div k='dialog'>
                    <Div k='titlebar'>Keyboard Shortcuts
                        <Div k='dismiss' role='button' aria-label='Close' {...onClick(onClose)}>close</Div>
                    </Div>
                    <Div k='body'>
                        {/* Zoom sits above every category: it's the one shortcut
                            that isn't ours, and it used to live in the header */}
                        <Div k='zoom'>
                            <Div k='action'>Zoom</Div>
                            <Div k='items'>
                                {[
                                    {key:'+', label:'In'},
                                    {key:'−', label:'Out'},
                                    {key:'0', label:'Reset'},
                                ].map(({key,label}) => (
                                    <Div k='item' key={label}>
                                        <Div k='keys'>
                                            <Key k={zoomModifier()}/>
                                            <Key k={key}/>
                                        </Div>
                                        <Div k='label'>{label}</Div>
                                    </Div>
                                ))}
                            </Div>
                        </Div>
                        <Div k='sections'>
                            {(() => {
                                const rowsNav: Row[] = toCatRows('Navigation')
                                const rowsActions: Row[] = toCatRows('Actions')
                                const rowsSel: Row[] = toCatRows('Selection')
                                const rowsSearch: Row[] = toCatRows('Search')
                                const rowsHist: Row[] = toCatRows('History')
                                const rowsGen: Row[] = [
                                    { action: 'Open Shortcuts', keys: <Key k='K'/>, keysText: 'k' },
                                    [...toCatRows('General')],
                                    { action: 'Close Dialogs and Modals', keys: <Key k='Esc'/>, keysText: 'esc escape' },
                                    { action: 'Activate Selected Button', keys: <Key k='Space'/>, keysText: 'space' },
                                    { action: 'Confirm or Submit', keys: <Key k='Enter'/>, keysText: 'enter return' },
                                ].flat()
                                // MOUSE GESTURES: modifier + click. Sourced from hotkeys.GESTURES
                                // (display-only; the handlers live in module.tsx / chain.tsx).
                                const rowsMouse: Row[] = hotkeys.GESTURES.map(g => {
                                    const caps = [...hotkeys.KeyMod.toStrings(g.mod), 'Click']
                                    return {
                                        action: g.desc,
                                        keys: caps.map(c => <Key key={c} k={c}/>),
                                        keysText: caps.join(' ').toLowerCase(),
                                    }
                                })
                                return (
                                    <>
                                        <Section title='Navigation' rows={rowsNav}/>
                                        <Section title='Actions' rows={rowsActions}/>
                                        <Section title='Selection' rows={rowsSel}/>
                                        <Section title='Search' rows={rowsSearch}/>
                                        <Section title='History' rows={rowsHist}/>
                                        <Section title='General' rows={rowsGen}/>
                                        <Section title='Mouse' rows={rowsMouse}/>
                                    </>
                                )
                            })()}
                        </Div>

                        <Div k='actions'>
                            <Div k='cta primary' {...onClick(onClose)}>Got it</Div>
                        </Div>
                        <Div k='footnote'>Press <Key k='K'/> any time to show this dialog</Div>
                    </Div>
                </Div>
            </D>
        </Loft>
    )
}

export function DeviceIcon () {
    return (
        <Div k='svgicon'>
            <svg width='21' height='13' viewBox='0 0 21 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <circle className='fill' cx='17' cy='9' r='1' fill='#C3C5C7'/>
                <circle className='fill' cx='11' cy='9' r='1' fill='#C3C5C7'/>
                <path className='fill' fillRule='evenodd' clipRule='evenodd'
                    d='M1 0C0.447715 0 0 0.447715 0 1V12C0 12.5523 0.447715 13 1 13H20C20.5523 13 21 12.5523 21 12V1C21 0.447715 20.5523 0 20 0H1ZM17 11C18.1046 11 19 10.1046 19 9C19 7.89543 18.1046 7 17 7C15.8954 7 15 7.89543 15 9C15 10.1046 15.8954 11 17 11ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM19 3.4998C19 4.88051 17.8807 5.9998 16.5 5.9998C15.1193 5.9998 14 4.88051 14 3.4998C14 2.29032 14.8589 1.28144 16 1.0498V2.9998H17V1.0498C18.1411 1.28144 19 2.29032 19 3.4998ZM10.5 5.94999C11.8807 5.94999 13 4.8307 13 3.44999C13 2.24051 12.1411 1.23164 11 1V2.94999H10V1C8.85888 1.23164 8 2.24051 8 3.44999C8 4.8307 9.11929 5.94999 10.5 5.94999ZM7 3.44999C7 4.8307 5.88071 5.94999 4.5 5.94999C3.11929 5.94999 2 4.8307 2 3.44999C2 2.24051 2.85888 1.23164 4 1V2.94999H5V1C6.14112 1.23164 7 2.24051 7 3.44999Z'
                    fill='#C3C5C7'/>
            </svg>
        </Div>
    )
}

export function NodeIcon ({size,s} : {size: string|number, s?:TStyle} ) {
    return (
        <Div k='svgicon' s={s}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                fill="currentColor"
                preserveAspectRatio="xMidYMid meet"
            >
                <g transform="scale(5) translate(0,3)">
                    <rect x="5"  y="12" width="1" height="2" />
                    <rect x="14" y="12" width="1" height="2" />
                    <rect x="5"  y="0"  width="1" height="2" />
                    <rect x="14" y="0"  width="1" height="2" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 2C0 1.44772 0.447715 1 1 1H4V3H7V1H13V3H16V1H19C19.5523 1 20 1.44772 20 2V12C20 12.5523 19.5523 13 19 13H16V11H13V13H7V11H4V13H1C0.447715 13 0 12.5523 0 12V2Z"
                    />
                </g>
            </svg>
        </Div>
    )
}

// Target mode toggle: Gosta's Square.svg (round 6), two concentric rounded
// squares. OFF is the neutral outline as designed; ON goes red and fills the
// inner square so the lit state reads at a glance (Pro Tools target button).
export function TargetIcon ({ size = 20, active = false } : { size?: number|string, active?: boolean }) {
    const color = active ? '#e85050' : '#CDCDCE'
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={active ? 'Target on' : 'Target off'}
            role="img"
        >
            <path d="M16.2002 3C16.2002 2.33726 15.6627 1.7998 15 1.7998H3C2.33726 1.7998 1.7998 2.33726 1.7998 3V15C1.7998 15.6627 2.33726 16.2002 3 16.2002H15C15.6627 16.2002 16.2002 15.6627 16.2002 15V3ZM17.7998 15C17.7998 16.5464 16.5464 17.7998 15 17.7998H3C1.4536 17.7998 0.200195 16.5464 0.200195 15V3C0.200195 1.4536 1.4536 0.200195 3 0.200195H15C16.5464 0.200195 17.7998 1.4536 17.7998 3V15Z" fill={color}/>
            {active
                ? <rect x="4.2002" y="4.2002" width="9.5996" height="9.5996" rx="1.8" fill={color}/>
                : <path d="M12.2002 6C12.2002 5.88954 12.1105 5.7998 12 5.7998H6C5.88954 5.7998 5.7998 5.88954 5.7998 6V12C5.7998 12.1105 5.88954 12.2002 6 12.2002H12C12.1105 12.2002 12.2002 12.1105 12.2002 12V6ZM13.7998 12C13.7998 12.9941 12.9941 13.7998 12 13.7998H6C5.00589 13.7998 4.2002 12.9941 4.2002 12V6C4.2002 5.00589 5.00589 4.2002 6 4.2002H12C12.9941 4.2002 13.7998 5.00589 13.7998 6V12Z" fill={color}/>}
        </svg>
    )
}
  
export function ABGroupIcon ({size} : {size: string|number} ) {
    return (
        <Div k='svgicon'>
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                fill="currentColor"
                preserveAspectRatio="xMidYMid meet"
            >
                 <g transform="scale(1 -1) translate(0 -100)">
                  <g transform="scale(0.104167) translate(0,960)">
    <path d="M200-80q-50 0-85-35t-35-85q0-39 22.5-70t57.5-43v-87q0-50 35-85t85-35h160v-127q-35-12-57.5-43T360-760q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 70T520-647v127h160q50 0 85 35t35 85v87q35 12 57.5 43t22.5 70q0 50-35 85t-85 35q-50 0-85-35t-35-85q0-39 22.5-70t57.5-43v-87q0-17-11.5-28.5T680-440H520v127q35 12 57.5 43t22.5 70q0 50-35 85t-85 35q-50 0-85-35t-35-85q0-39 22.5-70t57.5-43v-127H280q-17 0-28.5 11.5T240-400v87q35 12 57.5 43t22.5 70q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T240-200q0-17-11.5-28.5T200-240q-17 0-28.5 11.5T160-200q0 17 11.5 28.5T200-160Zm280 0q17 0 28.5-11.5T520-200q0-17-11.5-28.5T480-240q-17 0-28.5 11.5T440-200q0 17 11.5 28.5T480-160Zm280 0q17 0 28.5-11.5T800-200q0-17-11.5-28.5T760-240q-17 0-28.5 11.5T720-200q0 17 11.5 28.5T760-160ZM480-720q17 0 28.5-11.5T520-760q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760q0 17 11.5 28.5T480-720Z"/>
  </g>
  </g>

            </svg>
        </Div>
    )
}
  

export function ProcIcon ({size} : {size: string|number} ) {
    return  (
        <Div k='svgicon'>
            <svg
                    width={size}
                    height={size}
                    viewBox="0 0 100 100"
                    fill='currentColor'
                    preserveAspectRatio="xMidYMid meet">
                {/* TOP bar */}
                <rect x="16.667" y="12.5"   width="66.667" height="8.333" />
                {/* BOTTOM bar */}
                <rect x="16.667" y="79.234" width="66.667" height="8.333" />
                {/* ARROW */}
                <path d="M45.833,20.833 L45.833,63.333 L35,52.499 L29.167,58.333 L50,79.167 
                    L70.833,58.333 L65,52.499 L54.167,63.333 L54.167,20.833 Z"/>
            </svg>
        </Div>
    )
}

export function SourceIcon ({size} : {size: string|number} ) {
    return  (
        <Div k='svgicon'>
            <svg
                    width={size}
                    height={size}
                    fill='currentColor'
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid meet">
                {/* BOTTOM bar */}
                <rect x="16.667" y="79.230" width="66.667" height="8.333" />
                {/* DOWN ARROW */}
                <path d="
                    M45.833,12.486
                    L45.833,63.333
                    L35.000,52.500
                    L29.167,58.333
                    L50.000,79.167
                    L70.833,58.333
                    L65.000,52.500
                    L54.167,63.333
                    L54.167,12.486
                    Z"/>
          </svg>
        </Div>
    )
}

export function DestIcon ({size} : {size: string|number} ) {
    return  (
        <Div k='svgicon'>
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                fill='currentColor'
                preserveAspectRatio="xMidYMid meet">
                {/* TOP bar */}
                <rect
                    x="16.667"
                    y="12.500"
                    width="66.667"
                    height="8.333"
                />
                {/* DOWN ARROW */}
                <path d="
                    M45.833,20.882
                    L45.833,71.730
                    L35.000,60.896
                    L29.167,66.730
                    L50.000,87.563
                    L70.833,66.730
                    L65.000,60.896
                    L54.167,71.730
                    L54.167,20.882
                    Z"/>
            </svg>
        </Div>
    )
}

import './demo.css'
import './shortcuts.css'
import * as hotkeys from './hotkeys'
import { IMidiController } from './logic'

type SupportedTag = 'b' | 'p' | 'em' | 'ul' | 'li' | 'h1' | 'h2' | 'h3' | 'h4'

/**
 * MAP DOM node (and children) to React element(s)
 * @param node 
 * @param key 
 * @returns 
 */
function nodeToElement (node: ChildNode, key: number): React.ReactNode {
  // TEXT
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent
  }

  // ELEMENT
  if (node.nodeType === Node.ELEMENT_NODE) {
    const el = node as HTMLElement
    const tag = el.tagName.toLowerCase() as SupportedTag

    // map attributes
    const props: Record<string, any> = { key }
    for (let i = 0; i < el.attributes.length; i++) {
      const attr = el.attributes[i]
      // map class → className
      if (attr.name === 'class') {
        props.className = attr.value
      } 
      else {
        props[attr.name] = attr.value
      }
    }
    // RECURSE
    const children = Array.from(el.childNodes).map(nodeToElement)
    // CREATE React element
    return React.createElement(tag, props, ...children)
  }

  // unsupported node types (comments, etc.)
  return null
}

/**
 * TRANSFORM string to React element collection
 * @param html 
 * @returns 
 */
export function parseHtml (html: string): React.ReactNode[] {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return Array.from(doc.body.childNodes)
    .map((node, idx) => nodeToElement(node, idx))
    .filter(_ => _)
}

/**
 * TRANSFORM string to React element collection, respecting line-breaks
 */
export function toHTML (html:string) : React.ReactNode[] {
    return html
        .split(/\n/)
        .map(_ => _.trimStart())
        // FILTER out leading empty line
        .filter((_,i) => i || _)
        // FILTER out trailing empty line
        .filter((_,i,a) => i + 1 < a.length || _)
        //.replace(/<b>(.+?)<\/b>/,g => g[1]
        .map((_,i) => _
            // PARAGRAPH
            ? <p key={i}>{parseHtml(_)}</p>
            // EMPTY line (BREAK)
            : <br key={i}/>
        )
}

/**
 * Welcome / Release Notes / Update dialog
 * mode='demo': Shows welcome text only (auto-opens on demo site)
 * mode='notes': Shows only changelog (opened from AppInfo)
 * mode='update': Shows version + changelog (auto-opens after version bump)
 */
export function DemoModal ({
        mode,
        dismiss,
        changelogHtml,
        version,
    }:{
        mode: 'demo' | 'notes' | 'update'
        dismiss:()=>void
        changelogHtml?:string|null
        version?:string
    }) {
    const ref = useRef(null)
    const [logExpand,setLogExpand] = useState(true)

    const isDemo = mode === 'demo'
    const title = isDemo
        ? 'Welcome to ProPatch Demo'
        : mode === 'update' && version
            ? `Updated to v${version}`
            : 'Release Notes'
    const body = isDemo ? toHTML(`
This is the full ProPatch application. Use this to understand ProPatch concepts and configure various use cases. The full configuration can be exported and used with a real ProPatch, no wasted effort!
The #1 job of a patchbay is to route audio with 100% transparency. To accomplish this, ProPatch uses a matrix of relays (a LOT of them). No FET switches, no buffers or games with gain staging - there are no electronics in the signal path, it  is effectively a "straight wire."
ProPatch signal chains are configured and managed using this application (Windows and MacOS). Create complex mono or stereo signal chains, including mults, mono to stereo Nodes, inserts, processors, AB groups for comparison  and many more intuitive and useful shortcuts.
How-to videos and documentation will be regularly added here - check back!
    `) : null
    const changelog = changelogHtml ? parseHtml(changelogHtml) : null

    useEffect(() => {
        const keyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.stopPropagation()
                dismiss()
            }
        }
        window.addEventListener('keydown', keyDown)
        return () => window.removeEventListener('keydown', keyDown)
    }, [])
    
    return (
        <div className={klass('modal','demo')} style={{display:'block'}} ref={ref}>
            <D k='dialog' style={{top:'40%'}}>
                <D k='titlebar'>
                    <D k='title'>{title}</D>
                    <D k={'dismiss'} {...onClick(dismiss)}>close</D>
                </D>
                <D k='body'>
                    {body && <D k='text'>{body}</D>}
                    {changelog &&
                        <D k={['log','expando']} {...onClick(() => setLogExpand(!logExpand))}>
                            <D k='header'>
                                <D k='title'>Change Log</D>
                                <D k={['expand','symbols']}>{
                                    logExpand
                                    ? 'keyboard_arrow_up'
                                    : 'keyboard_arrow_down'
                                }</D>
                            </D>
                            <D k={['body',logExpand && 'expanded']}>{changelog}</D>
                        </D>
                    }
                    <D k='actions'>
                        <D k={['cta','primary']} {...onClick(dismiss)}>Got it</D>
                    </D>
                </D>
            </D>
        </div>
    ) 
}

export interface ISessionPopControl {
    create (): void
    duplicate (): void
    rename? (): void
    load (session: ISession): void
    save? (): void
    lock? (lock:boolean): void
    remove? (): void
    revert? (): void
    saveas (): void
    copy (): void
    import (): void
    export (): void
    support? (): void
    midi?: {
        assignment?: string
        choices () : IMenuChoice[]
    }
}

export function SnapperMenu ({
        parent,
        session,
        sessions,
        control,
        close,
    } : {
        parent: RefObject<HTMLElement>
        session: ISession
        sessions: TRecSession
        control: ISessionPopControl
        close: () => void
    })
{
    const [search,setSearch] = useState<string>()
    const ref = useRef<HTMLDivElement>(null)

    useDismissOnEvent({ref:parent, clear: close})

    const all = Object
        .values(sessions)
        .sort((a,b) => b.meta.accessed.localeCompare(a.meta.accessed))
    // APPLY any active name filtering
    const filter = (s: string) => !search || s.toLowerCase().includes(search)
    const filtered = all.filter(({name}) => filter(name))
    const {locked} = session.meta
    const note = session.meta.midi ? MidiNote.toString(session.meta.midi) : undefined

    const el = true

    // Top section: New Session through Search
    const topItems: IMenuChoice[] = [
        {
            el,
            label: <D k={['new','action']}><D k='icon'>add</D><D k='label'>New Session</D></D>,
            choose: control.create,
        },
        {
            el,
            label: <D k={['new','action']}><D k='icon'>file_copy</D><D k='label'>Duplicate Current Session</D></D>,
            choose: control.duplicate,
        },
        {
            divider: 'top',
            el,
            label: <D k={['action',!control.save && 'disabled']}><D k='icon'>save</D><D k='label'>Save</D></D>,
            disabled: !control.save,
            choose: control.save,
        },
        {
            el,
            label: <D k={['action']}><D k='icon'>save_as</D><D k='label'>Save As...</D></D>,
            choose: control.saveas,
        },
        {
            el,
            label: <D k={['action']}><D k='icon'>file_copy</D><D k='label'>Save a Copy...</D></D>,
            choose: control.copy,
        },
        {
            el,
            label: <D k={['action',!control.rename && 'disabled']}><D k='icon'>move_item</D><D k='label'>Rename...</D></D>,
            choose: control.rename,
            disabled: !control.rename,
        },
        {
            el,
            label: <D k={['action',!control.lock && 'disabled']}>
                <D k='icon'>{locked ? 'lock_open_right' : 'lock'}</D>
                <D k='label'>{locked ? 'Unlock' : 'Lock'}</D>
             </D>,
            choose: () => { control.lock && control.lock(!locked); return true },
            disabled: !control.lock,
        },
        {
            el,
            label: <D k={['action',!control.revert && 'disabled']}><D k='icon'>backspace</D><D k='label'>Revert</D></D>,
            choose: control.revert,
            disabled: !control.revert,
        },
        {
            el,
            label: <D k={['action',!control.remove && 'disabled']}><D k='icon'>delete</D><D k='label'>Delete</D></D>,
            choose: control.remove,
            disabled: !control.remove,
        },
        {
            el,
            label: <D k={['action',!control.midi && 'disabled']}><D k='icon'><MidiPortIcon size={18}/></D><D k='label'>{`MIDI${note ? ` (${note})` : ''}`}</D></D>,
            choices:control.midi?.choices ?? [],
            disabled: !control.midi,
        },
        {
            el,
            divider: 'top',
            label: <D k='header'>Sessions</D>,
        },
        {
            el,
            label: <D k='search'>
                <Div k="icon">
                    <span className="symbols">search</span>
                </Div>
                <SearchBox
                    k='searchbox'
                    onEdit={s => {
                        s = s.trim()
                        setSearch(s ? s.toLowerCase() : undefined)
                    }}
                />
            </D>,
        },
    ]

    // Middle section: Session list (scrollable)
    const sessionItems: IMenuChoice[] = filtered.length
        ? filtered.map(s  =>(
            {
                el,
                label: <D k={['session',s.name === session.name && 'loaded']}>
                    {(s.meta.locked || s.meta.immutable) &&
                        <D k={['locked',s.meta.immutable && 'immutable']}>lock</D>}
                    {s.name === session.name && <D k={['loaded']}>check</D>}
                    <D k='name'>{s.name}</D>
                </D>,
                choose:  () => control.load(s),
        }))
        : [
            all.length
            ? { el, label: <D k={['empty','session']}>No sessions found for search</D>, disabled: true }
            : { el, label: <D k={['empty','session']}>No sessions loaded</D>, disabled: true  }
        ]

    // Bottom section: Import/Export/Support (always visible)
    const bottomItems: IMenuChoice[] = [
        {
            el,
            divider: 'top',
            label: <D k={['action']}><D k='icon'>download</D><D k='label'>Import...</D></D>,
            choose: control.import
        },
        {
            el,
            label: <D k={['action']}><D k='icon'>upload</D><D k='label'>Export...</D></D>,
            choose: control.export
        },
        ...control.support ? [{
            el,
            divider: 'top' as const,
            label: <D k={['action']}><D k='icon'>build</D><D k='label'>Send to Support...</D></D>,
            choose: control.support
        }] : [],
    ]

    return <D k='snap-menu'>
        <MenuChoices
            items={topItems}
            close={close}
            parent={{ ref:parent }}
        />
        <D k='sessions-scroll'>
            <MenuChoices
                items={sessionItems}
                close={close}
                parent={{ ref:parent }}
            />
        </D>
        <MenuChoices
            items={bottomItems}
            close={close}
            parent={{ ref:parent }}
        />
    </D>

    /*
    return <D k='snap-menu'>
        <D k='create'>
            <D k={['new','action']} {...($onClick(control.create))}><D k='icon'>add</D>New Session</D>
        </D>
        <D k='persist'>
            <D k={['action',!control.save && 'disabled']} {...(onClick(control.save))}><D k='icon'>save</D>Save</D>
            <D k={['action']}  {...$onClick(control.saveas)}><D k='icon'>save_as</D>Save As...</D>
            <D k={['action']}  {...$onClick(control.copy)}><D k='icon'>file_copy</D>Save a Copy...</D>
            <D k={['action',!control.lock && 'disabled']} {...(onClick(lock))}>
                <D k='icon'>{locked ? 'lock_open_right' : 'lock'}</D>
                {locked ? 'Unlock' : 'Lock'}
             </D>
            <D k={['action',!control.revert && 'disabled']} {...($onClick(control.revert))}><D k='icon'>backspace</D>Revert</D>
            <D k={['action',!control.remove && 'disabled']} {...($onClick(control.remove))}><D k='icon'>delete</D>Delete</D>
            <MidiSubMenu/>
        </D>
        <D k='snaps'>
            <D k='header'>Sessions</D>
            <D k='search'>
                <Div k="icon">
                    <span className="symbols">search</span>
                </Div>
                <SearchBox 
                    k='searchbox'
                    onEdit={s => {
                        s = s.trim()
                        setSearch(s ? s.toLowerCase() : undefined)
                    }}
                />
            </D>
            <D k='items'>
                {filtered.length
                    ? filtered.map(s  =>
                        <D k={['session',s.name === session.name && 'loaded']} {...$onClick(() => control.load(s))}>
                            {(s.meta.locked || s.meta.immutable) &&
                                <D k={['locked',s.meta.immutable && 'immutable']}>lock</D>}
                            {s.name === session.name && <D k='loaded'>check</D>}
                            <D k='name'>{s.name}</D>
                        </D>
                    )
                    : all.length
                    ? <D k={['empty','session']}>No sessions found for search</D>
                    : <D k={['empty','session']}>No sessions loaded</D>
                }
            </D>
        </D>
        <D k='migrate'>
            <D k={['action']} {...$onClick(control.import)}><D k='icon'>download</D>Import...</D>
            <D k={['action']} {...$onClick(control.export)}><D k='icon'>upload</D>Export...</D>
        </D>
    </D>
    */
}

export interface ISessionControl {
    create (): void
    duplicate (): void
    load (session: ISession): void
    rename (): void
    save (): void
    saveas (): void
    copy (): void
    revert (): void
    remove (): void
    lock (lock:boolean): void
    import (): void
    export (): void
    support? (): void
    midi (note?: IMidiNote) : void
}

export function Snapper ({
        midi,
        session,
        dirty,
        sessions,
        controllers,
    } : {
        midi?: IMidiLearn
        session: ISession
        dirty: boolean
        sessions: TRecSession
        controllers: {
            session: ISessionControl
            midi: IMidiController
        }
    })
{
    const ref = useRef<HTMLDivElement>(null)
    const [expanded,setExpanded] = useState<boolean>(false)
    const readonly = session.meta.immutable || session.meta.locked
    const control = controllers.session
    const note = session.meta.midi
    const assignment =  note ? MidiNote.toString(note) : undefined
    const clear = () => setExpanded(false)
    const $control: ISessionPopControl = {
        ...control,
        rename: !readonly ? control.rename : undefined,
        save: (!readonly && dirty) ? control.save: undefined,
        remove: !readonly ? control.remove : undefined,
        revert: dirty ? control.revert : undefined,
        lock: !session.meta.immutable ? control.lock : undefined,
        midi: {
            assignment,
            choices: () =>
                controllers.midi.choices({
                    assigned: note ? {
                        note,
                        label: MidiNote.toString(note),
                    } : undefined,
                    assign: note => {
                        control.midi(note)
                        clear()
                    }
                })
        }
    }

    const learner = {session: session.id}
    //useDismissOnEvent({ref,clear,ignore:'menu-item'})

    return (
        <D
                id='session' 
                k={['snapper',midi && 'midi-learn', midi?.state(learner) === 'learning' && 'learning']}
                ref={ref}
                {...onClick(() => {
                    // MIDI learning?
                    if (midi) {
                        midi.learn(learner)
                    }
                    else {
                        setExpanded(!expanded)
                    }
                })}>
            <D k='name'>{session.name}</D>
            <D k={['expando','symbols']}>
                more_vert
            </D>
            {
                expanded && 
                <SnapperMenu
                    parent={ref}
                    control={$control}
                    session={session}
                    sessions={sessions}
                    close={clear}
                />
            }
        </D>
    )
}

export function CTAButton ({
    k,
    disabled,
    selected,
    click,
    children,
} : {
    k?: TKlass
    disabled?: boolean
    selected?: boolean
    click: (e:UIEvent) => void
    children: ReactNode[]|ReactNode
}) {
    const ref = useRef<HTMLDivElement>(null)
    const eligble = useRef<boolean|null>(null)

    // ELIGIBLE to be "ACTUATED"?
    const $eligible = !!selected && !disabled
    eligble.current = $eligible

    // SPACE to "CLICK"
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if ((e.key === ' ' || e.key === 'Enter') && eligble.current && click) {
                setTimeout(() => click(e),0)
                e.preventDefault()
                e.stopPropagation()
            }
        }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [ref])

    return <D k={['cta',disabled && 'disabled',selected && 'selected',k]}
            {...onClick(!disabled ? click : undefined)}>
        {children}
    </D>
}

export function MidiLearn ({
    connected,
    selected,
    enabled,
    setSelected,
    onDisconnected,
} : {
    connected: boolean
    selected: boolean
    enabled: boolean
    setSelected: (v:boolean) => void
    onDisconnected: () => void
})
{
    useEffect(() => {
        if (!selected) return
        const handleESC = (e:KeyboardEvent) => {
            if (e.key === 'Escape') {
                setSelected(false)
            }
        }
        document.addEventListener('keydown', handleESC);
        return () => document.removeEventListener('keydown', handleESC)
    }, [selected])

    return <D
            id='midi'
            k={['cta','top',!connected && 'midi-bad',selected && 'selected',enabled && 'enabled']}
            role='button'
            aria-label={connected ? 'Toggle MIDI Learn' : 'Configure MIDI'}
            aria-disabled={connected && !enabled}
            {...onClick(() => connected ? setSelected(!selected) : onDisconnected())}>
        {/* Both variants occupy the same 20px layout slot: the connected glyph
            inks a 24px SVG into it, while the supplied OFF glyph is natively 20px. */}
        {connected
            ? <MidiPortIcon size='24px'/>
            : <MidiOffIcon size='20px'/>
        }MIDI
    </D>
}

// Dedicated disconnected state supplied by design (midiOFF.svg).
function MidiOffIcon ({size} : {size: string|number}) {
  return <svg
    className='midi-off-icon'
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M15.6748 15.6748L15.957 15.3809C17.3193 13.8877 18 12.0938 18 10C18 7.76668 17.2248 5.87519 15.6748 4.3252C14.1248 2.77521 12.2333 2 10 2C7.76668 2.00001 5.87519 2.7752 4.3252 4.3252L3.2793 3.2793C4.13401 2.42436 5.13859 1.74681 6.29395 1.24805C7.44946 0.749217 8.68425 0.500038 9.99805 0.5C11.3119 0.5 12.5471 0.749459 13.7031 1.24805C14.8593 1.74671 15.8655 2.42349 16.7207 3.27832C17.5759 4.13315 18.2531 5.13836 18.752 6.29395C19.2508 7.44946 19.5 8.68424 19.5 9.99805C19.5 11.3119 19.2505 12.5471 18.752 13.7031C18.2533 14.8593 17.5765 15.8655 16.7217 16.7207L15.6748 15.6748ZM10.002 19.5C8.6881 19.5 7.45295 19.2506 6.29688 18.752C5.14072 18.2533 4.13451 17.5765 3.2793 16.7217C2.42414 15.8669 1.7469 14.8616 1.24805 13.7061C0.749222 12.5505 0.500032 11.3158 0.5 10.002C0.5 8.68811 0.749447 7.45294 1.24805 6.29687C1.53921 5.62182 1.89308 4.99922 2.30566 4.42676L3.35938 5.48047C2.45446 6.78797 2 8.29356 2 10C2 12.2333 2.77521 14.1248 4.3252 15.6748C5.87519 17.2248 7.76668 18 10 18C11.7065 18 13.213 17.5466 14.5205 16.6416L15.5742 17.6953C15.0024 18.1077 14.3803 18.4609 13.7061 18.752C12.5505 19.2508 11.3158 19.5 10.002 19.5Z" fill="#CDCDCE"/>
    <path d="M1.93966 2.06088L3.00032 1.00022L19 16.9999L17.9393 18.0605L1.93966 2.06088Z" fill="#CDCDCE"/>
    <path d="M16.2045 9.29552C16.0075 9.09851 15.7726 9 15.5 9C15.2274 9 14.9925 9.09851 14.7955 9.29552C14.5985 9.49252 14.5 9.72735 14.5 10C14.5 10.2726 14.5985 10.5075 14.7955 10.7045C14.9925 10.9015 15.2274 11 15.5 11C15.7726 11 16.0075 10.9015 16.2045 10.7045C16.4015 10.5075 16.5 10.2726 16.5 10C16.5 9.72735 16.4015 9.49252 16.2045 9.29552Z" fill="#CDCDCE"/>
    <path d="M10.7045 14.5963C10.5075 14.3993 10.2726 14.3008 10 14.3008C9.72735 14.3008 9.49252 14.3993 9.29552 14.5963C9.09851 14.7933 9 15.0281 9 15.3008C9 15.5734 9.09851 15.8083 9.29552 16.0053C9.49252 16.2023 9.72735 16.3008 10 16.3008C10.2726 16.3008 10.5075 16.2023 10.7045 16.0053C10.9015 15.8083 11 15.5734 11 15.3008C11 15.0281 10.9015 14.7933 10.7045 14.5963Z" fill="#CDCDCE"/>
    <path d="M6.9037 12.9947C6.70669 12.7977 6.47187 12.6992 6.19922 12.6992C5.92657 12.6992 5.69174 12.7977 5.49474 12.9947C5.29773 13.1917 5.19922 13.4266 5.19922 13.6992C5.19922 13.9719 5.29773 14.2067 5.49474 14.4037C5.69174 14.6007 5.92657 14.6992 6.19922 14.6992C6.47187 14.6992 6.70669 14.6007 6.9037 14.4037C7.10071 14.2067 7.19922 13.9719 7.19922 13.6992C7.19922 13.4266 7.10071 13.1917 6.9037 12.9947Z" fill="#CDCDCE"/>
    <path d="M5.20448 9.29552C5.00748 9.09851 4.77265 9 4.5 9C4.22735 9 3.99253 9.09851 3.79552 9.29552C3.59851 9.49252 3.5 9.72735 3.5 10C3.5 10.2726 3.59851 10.5075 3.79552 10.7045C3.99253 10.9015 4.22735 11 4.5 11C4.77265 11 5.00748 10.9015 5.20448 10.7045C5.40149 10.5075 5.5 10.2726 5.5 10C5.5 9.72735 5.40149 9.49252 5.20448 9.29552Z" fill="#CDCDCE"/>
    <rect x="9" y="2" width="2" height="2" fill="#CDCDCE"/>
  </svg>
}

// MIDI DIN glyph from the Figma header spec (node 3463:60743 "btn MIDI"):
// thin ring + five pins + notch tab, rotated 180 like the Figma instance.
function MidiPortIcon ({size} : {size: string|number} ) {
  return <svg
    className='midi-port-icon'
    width={size}
    height={size}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    shapeRendering='geometricPrecision'
    fill="currentColor"
  >
  <g transform="rotate(180 12 12)">
    <path d="M12.0017 21.5C10.6877 21.5 9.45271 21.2506 8.29658 20.752C7.14042 20.2533 6.13474 19.5766 5.27953 18.7217C4.42429 17.8669 3.74723 16.8616 3.24835 15.706C2.74947 14.5504 2.50002 13.3156 2.50002 12.0017C2.50002 10.6877 2.74936 9.45271 3.24803 8.29657C3.74669 7.14042 4.42344 6.13474 5.27828 5.27953C6.13313 4.42429 7.13837 3.74723 8.294 3.24835C9.44962 2.74947 10.6844 2.50002 11.9983 2.50002C13.3123 2.50002 14.5473 2.74936 15.7034 3.24803C16.8596 3.74669 17.8653 4.42344 18.7205 5.27827C19.5757 6.13312 20.2528 7.13837 20.7517 8.294C21.2505 9.44962 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5766 17.8653 18.7217 18.7205C17.8669 19.5757 16.8616 20.2528 15.706 20.7517C14.5504 21.2505 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"/>
    <path d="M5.79552 12.7045C5.99252 12.9015 6.22735 13 6.5 13C6.77265 13 7.00748 12.9015 7.20448 12.7045C7.40149 12.5075 7.5 12.2726 7.5 12C7.5 11.7274 7.40149 11.4925 7.20448 11.2955C7.00748 11.0985 6.77265 11 6.5 11C6.22735 11 5.99252 11.0985 5.79552 11.2955C5.59851 11.4925 5.5 11.7274 5.5 12C5.5 12.2726 5.59851 12.5075 5.79552 12.7045Z"/>
    <path d="M7.5963 9.00448C7.79331 9.20149 8.02813 9.3 8.30078 9.3C8.57343 9.3 8.80826 9.20149 9.00526 9.00448C9.20227 8.80747 9.30078 8.57265 9.30078 8.3C9.30078 8.02735 9.20227 7.79252 9.00526 7.59552C8.80826 7.39851 8.57343 7.3 8.30078 7.3C8.02813 7.3 7.79331 7.39851 7.5963 7.59552C7.39929 7.79252 7.30078 8.02735 7.30078 8.3C7.30078 8.57265 7.39929 8.80747 7.5963 9.00448Z"/>
    <path d="M11.2955 7.40448C11.4925 7.60149 11.7274 7.7 12 7.7C12.2726 7.7 12.5075 7.60149 12.7045 7.40448C12.9015 7.20748 13 6.97265 13 6.7C13 6.42735 12.9015 6.19252 12.7045 5.99552C12.5075 5.79851 12.2726 5.7 12 5.7C11.7274 5.7 11.4925 5.79851 11.2955 5.99552C11.0985 6.19252 11 6.42735 11 6.7C11 6.97265 11.0985 7.20748 11.2955 7.40448Z"/>
    <path d="M15.0963 9.00448C15.2933 9.20149 15.5281 9.3 15.8008 9.3C16.0734 9.3 16.3083 9.20149 16.5053 9.00448C16.7023 8.80747 16.8008 8.57265 16.8008 8.3C16.8008 8.02735 16.7023 7.79252 16.5053 7.59552C16.3083 7.39851 16.0734 7.3 15.8008 7.3C15.5281 7.3 15.2933 7.39851 15.0963 7.59552C14.8993 7.79252 14.8008 8.02735 14.8008 8.3C14.8008 8.57265 14.8993 8.80747 15.0963 9.00448Z"/>
    <path d="M16.7955 12.7045C16.9925 12.9015 17.2274 13 17.5 13C17.7726 13 18.0075 12.9015 18.2045 12.7045C18.4015 12.5075 18.5 12.2726 18.5 12C18.5 11.7274 18.4015 11.4925 18.2045 11.2955C18.0075 11.0985 17.7726 11 17.5 11C17.2274 11 16.9925 11.0985 16.7955 11.2955C16.5985 11.4925 16.5 11.7274 16.5 12C16.5 12.2726 16.5985 12.5075 16.7955 12.7045Z"/>
    <rect x="13" y="20" width="2" height="2" transform="rotate(180 13 20)"/>
  </g>
  </svg>
}
